<template>
    <div v-if="currentRouteName === 'content-library'">
        <router-link :to="{ name: 'posts' }" @click="eventAnalytics('liste_annonces')" class="inline">
          <el-button @click="eventAnalytics('liste_annonces')">
            {{ $t("routes.adsListTitle") }}
          </el-button>
        </router-link>
        <router-link :to="{ name: 'post-new-model', params: {type : 'terrain' }}" class="inline">
          <el-button @click="eventAnalytics('creer_terrain')" type="warning" class="inline">
            {{ $t("posts.list.createLand") }}
          </el-button>
        </router-link>
        <router-link :to="{ name: 'post-new-model', params: {type : 'modele' }}" class="inline">
          <el-button @click="eventAnalytics('creer_modele')" type="primary" class="inline">
            {{ $t("posts.list.createModel") }}
          </el-button>
        </router-link>
    </div>
    <div v-else>
        <router-link :to="{ name: 'new-bien-vendu' }" class="inline" v-if="saisit_en_ligne && !isPromoteur && !isCmi && !isBailleurSocial">
            <el-button @click="eventAnalytics('creer_bien_vendu')">
                {{ $t("posts.list.newBienVendu") }}
            </el-button>
        </router-link>
        <router-link :to="{ name: 'content-library' }" class="inline" v-if="isCmi && saisit_en_ligne">
            <el-button @click="eventAnalytics('bibliotheque_contenus')">
                {{ $t("posts.list.contentLibrary") }}
            </el-button>
        </router-link>
        <el-button @click="$emit('reset-to-programs')" class="inline" v-if="filter.annonceParente != null">
            {{ $t("posts.list.backToProgramList") }}
        </el-button>
        <el-button @click="$emit('fetch-models')" type="warning" class="inline" v-if="saisit_en_ligne && !isPromoteur && !isCmi && !isBailleurSocial">
            {{ $t("posts.list.createAdFromModel") }}
        </el-button>
        <el-button @click="$emit('fetch-models-cmiste')" type="warning" class="inline" v-if="filter.annonceParente == null && saisit_en_ligne && isCmi">
            {{ $t("posts.list.createProgamFromModel") }}
        </el-button>
        <router-link :to="{ name: 'post-new' }" class="inline" v-if="saisit_en_ligne && !isPromoteur && !isBailleurSocial">
            <el-button type="primary">
                {{ $t("posts.list.createAd") }}
            </el-button>
        </router-link>
        <el-dropdown @command="handleCommandPromoter" v-if="isPromoteur && saisit_en_ligne && filter.annonceParente == null">
            <el-button type="primary">{{ $t("posts.list.createAd") }}...<em class="el-icon-arrow-down el-icon--right"></em></el-button>
            <el-dropdown-menu>
                <el-dropdown-item :command="{name: 'newProgram'}" v-if="isPromoteur && saisit_en_ligne">
                    {{ $t("posts.list.createProgram") }}
                </el-dropdown-item>
                <el-dropdown-item :command="{name: 'newLot'}" v-if="isPromoteur && saisit_en_ligne">
                    {{ $t("posts.list.createLot") }}
                </el-dropdown-item>
                <el-dropdown-item :command="{name: 'fetchModelsLots'}" v-if="saisit_en_ligne && isPromoteur">
                    {{ $t("posts.list.createProgamFromModel") }}
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown @command="handleCommandBailleur" v-if="isBailleurSocial && saisit_en_ligne && filter.annonceParente == null">
            <el-button type="primary">{{ $t("posts.list.createAd") }}...<em class="el-icon-arrow-down el-icon--right"></em></el-button>
            <el-dropdown-menu>
                <el-dropdown-item :command="{name: 'createAd'}" v-if="isBailleurSocial && saisit_en_ligne">
                    {{ $t("posts.list.createAd") }}
                </el-dropdown-item>
                <el-dropdown-item :command="{name: 'newProgram'}" v-if="isBailleurSocial && saisit_en_ligne">
                    {{ $t("posts.list.createProgram") }}
                </el-dropdown-item>
                <el-dropdown-item :command="{name: 'newLot'}" v-if="isBailleurSocial && saisit_en_ligne">
                    {{ $t("posts.list.createLot") }}
                </el-dropdown-item>
                <el-dropdown-item :command="{name: 'fetchModels'}" v-if="saisit_en_ligne && isBailleurSocial">
                    {{ $t("posts.list.createAdFromModel") }}
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <el-button @click="$emit('fetch-models-lots')" type="warning" class="inline" v-if="filter.annonceParente != null && saisit_en_ligne && isPromoteur">
            {{ $t("posts.list.createlotFromModel") }}
        </el-button>
        <router-link :to="{ name: 'post-new' }" class="inline" v-if="filter.annonceParente != null && (isPromoteur || isBailleurSocial) && saisit_en_ligne">
            <el-button type="primary" @click="eventAnalytics('creer_lot_prom_page_lots')">
                {{ $t("posts.list.createLot") }}
            </el-button>
        </router-link>
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import ElButton from '../../../../components/Button'

export default {
  name: 'ButtonsHeaderList',
  components: {
    ElButton
  },
  data () {
    return {}
  },
  computed: {
    ...mapState('postsListImmo', ['filter', 'results']),
    ...mapGetters([
      'hasMultiAccounts',
      'isMainAccount',
      'isSubAdmin',
      'isSubUser',
      'getOfferTypes',
      'getPickerOptionsShortcuts',
      'isPromoteur',
      'saisit_en_ligne',
      'isBailleurSocial',
      'isCmi',
      'getSitimmoUser'
    ]),
    userFilter () {
      return this.filter.user
    },
    currentRouteName () {
      return this.$route.name
    }
  },
  methods: {
    ...mapMutations('postsListImmo', [
      'setPage',
      'setLimit',
      'setSort',
      'setSearch',
      'setFilter',
      'addFilter',
      'setOffset',
      'setLimit',
      'setResults',
      'resetFilter',
      'SET_CREATION_PROGRAMME',
      'SET_ANNONCE_PARENTE'
    ]),
    eventAnalytics (category) {
      this.$ga.event('annonce', 'clic', category, this.getSitimmoUser.id)
    },
    async handleCommandPromoter (command) {
      if (command.name === 'fetchModels') {
        this.$emit('fetch-models')
      }
      if (command.name === 'fetchModelsLots') {
        this.eventAnalytics('creer_programme_prom_depuis_modele')
        this.$emit('fetch-models-lots')
      }
      if (command.name === 'newProgram') {
        this.eventAnalytics('creer_programme_prom')
        this.SET_ANNONCE_PARENTE(null)
        this.$router.push(
          {
            name: 'post-new'
          }
        )
      }
      if (command.name === 'newLot') {
        this.eventAnalytics('creer_lot_prom')
        this.$emit('gestion-modal-new-lot')
      }
    },
    async handleCommandBailleur (command) {
      if (command.name === 'createAd') {
        this.$router.push({
          name: 'post-new'
        })
      }
      if (command.name === 'fetchModels') {
        this.$emit('fetch-models')
      }
      if (command.name === 'fetchModelsLots') {
        this.$emit('fetch-models-lots')
      }
      if (command.name === 'newProgram') {
        // this.setFilter({ creationProgramme: true })
        this.$store.commit('posts/setFilter', { creationProgramme: true })
        this.$router.push(
          {
            name: 'post-new'
          }
        )
      }
      if (command.name === 'newLot') {
        this.$emit('gestion-modal-new-lot')
      }
    }
  }
}

</script>
